import React from 'react';

function DateInput(props) {
    return (
        <input {...props} type="date" className="form-control" />
    );
}

export default DateInput;